module.exports = __webpack_public_path__ + "static/media/koyo.39467e42.png";